import type { ByteValue } from "utils/byteValues";

export interface Location {
  name: string;
  description: string;
  endpoint?: string;
  available?: boolean;
  country?: string;
}

// TODO: Bridge to legacy GPUInstanceType shape; migrate consumers to CloudCred proto.
export interface InstanceCloudCred {
  id: string;
  name: string;
  baseDns?: string;
  status: string;
  platform: string;
  platformId: string;
  platformRegion: string;
  platformType: string;
  version?: string;
  tenantType: string;
  createdAt?: string;
  locations: Location[];
}
interface CurrencyAmount {
  currency: string;
  amount: string;
}

interface SupportedStorage {
  count?: number;
  size: string;
  /** Original legacy value used by create flows before byte-valued display normalization. */
  legacy_size?: string;
  type: string;
  price_per_gb_hr?: CurrencyAmount;
  max_size?: string;
  min_size?: string;
  type_label?: string;
  size_bytes?: ByteValue;
  min_size_bytes?: ByteValue;
  max_size_bytes?: ByteValue;
}
interface Prices {
  operating_system: string;
  instance_type: string;
  term_type: string;
  unit: string;
  price_usd: string;
  usage_type: string;
}
export interface GPUInstanceType {
  type: string;
  supported_gpus: {
    count: number;
    memory: string;
    memory_bytes?: ByteValue;
    manufacturer: string;
    name: string;
    network_details?: string;
    memory_details?: string;
  }[];
  quota: {
    on_demand: {};
    spot: {};
    reserved: {
      id: string;
      name: string;
      maximum: number;
      current: number;
      unit: string;
    };
  };
  vcpu: number;
  memory: number | string;
  memory_bytes?: ByteValue;
  stoppable?: boolean;
  default_price: string;
  supported_storage: SupportedStorage[];
  network_performance: string;
  prices: Prices[];
  architecture?: string;
  supported_architectures: string[];
  supportedArchitectures?: string[];
  clock_speed_in_ghz: string;
  supported_num_cores: [];
  available_azs: [];
  default_cores: number;
  maximum_network_interfaces: number;
  cloud_creds?: InstanceCloudCred[];
  elastic_root_volume: boolean;
  location?: string;
  available_locations?: string[];
  available_sublocations?: string[];
  sub_location?: string;
  base_price?: CurrencyAmount;
  location_prices?: Record<string, CurrencyAmount>;
  rebootable?: boolean;
  can_modify_firewall_rules?: boolean;
  sub_location_type_changeable?: boolean;
  is_available?: boolean;
  preemptible?: boolean;
  estimated_deploy_time?: string;
  provider?: string;
  cloud?: string;
  cloud_cred_id?: string;
  cloud_cred?: {
    cloud_cred_id?: string;
    provider_id?: string;
    labels?: Record<string, string>;
    status?: string;
    name?: string;
    platform_region?: string;
    tenant_type?: string | number;
  };
}

export const GetProviderName = (
  instanceType: GPUInstanceType | undefined | null,
): string | undefined => {
  if (!instanceType) {
    return undefined;
  }

  // By default, use the cloud from the instance type
  let cloud = instanceType.cloud;
  if (cloud != undefined && cloud != "") {
    return cloud.toUpperCase();
  }

  // If no cloud is set, use the provider from the instance type
  let provider = instanceType.provider;
  if (provider != undefined && provider != "") {
    return provider.toUpperCase();
  }

  // If no cloud or provider is set, return undefined
  return undefined;
};

export const GetCloudName = (
  instanceType: GPUInstanceType | undefined,
): string | undefined => {
  if (!instanceType) {
    return undefined;
  }
  if (!!instanceType.cloud && !!instanceType.provider) {
    return `${instanceType.provider}`;
  }

  return undefined;
};
